// src/services/securityFrameworkService.js
import api from '../api/apiClient';

const securityFrameworkService = {
  getSecurityFramework: async (analysisId) => {
    try {
      return await api.get(`/analyses/${analysisId}/security-framework`);
    } catch (error) {
      console.error('Error fetching security framework:', error);
      throw error;
    }
  },

  saveSecurityFramework: async (analysisId, data) => {
    try {
      console.log("Sending security framework data to API:", data);
      return await api.put(`/analyses/${analysisId}/security-framework`, {
        data: {
          frameworks: data.frameworks,
          selectedRules: data.selectedRules,
          ruleBusinessValues: data.ruleBusinessValues || {},
          ruleDreadedEvents: data.ruleDreadedEvents || {},
          ruleGapComments: data.ruleGapComments || {},
          frameworkNamesCache: data.frameworkNamesCache || {},
          summary: data.summary || [],
        }
      });
    } catch (error) {
      console.error('Error saving security framework:', error);
      throw error;
    }
  },

  formatSecurityFrameworkData: (apiData) => {
    if (!apiData || !apiData.data) {
      return {
        frameworks: [],
        selectedRules: {},
        ruleBusinessValues: {},
        ruleDreadedEvents: {},
        ruleGapComments: {},
        frameworkNamesCache: {},
        summary: []
      };
    }

    // Check if data is nested inside data property
    const data = apiData.data.data || apiData.data;

    return {
      frameworks: data.frameworks || [],
      selectedRules: data.selectedRules || {},
      ruleBusinessValues: data.ruleBusinessValues || {},
      ruleDreadedEvents: data.ruleDreadedEvents || {},
      ruleGapComments: data.ruleGapComments || {},
      frameworkNamesCache: data.frameworkNamesCache || {},
      summary: data.summary || []
    };
  }
};

export default securityFrameworkService;